import { Button, Modal } from 'semantic-ui-react';
import authService from '../../services/api/auth';
import moment from 'moment';

const EditUsersModal = (props) => {
  const { set_openModal, user, getUsers } = props;
  const { id } = user;

  const saveUser = () => {
    authService
      .editUser({ id })
      .then(() => {
        getUsers();
        set_openModal(false);
      })
      .catch((error) => {
        console.log(`An error occurred trying to edit the user ${error}.`);
      });
  };

  return (
    <Modal
      open
      onClose={() => set_openModal(false)}
      size="large"
      style={{ backgroundColor: 'white' }}
    >
      <Modal.Header style={{ color: 'black' }}>Ver usuario</Modal.Header>
      <Modal.Content scrolling style={{ height: '600px' }}>
        <Modal.Description style={{ color: 'black' }}>
          <p>Nombre: {user.name}</p>
          <p>Usuario: {user.email}</p>
          <p>
            Ultima modificación:{' '}
            {moment.tz(user.updatedAt, 'America/Bogota').format('DD-MM-YYYY hh:mm a')}
          </p>
          <p>Accesos autorizados: {user.status.join(', ')}</p>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button secundary onClick={() => set_openModal('')}>
          Volver
        </Button>
        <Button primary onClick={saveUser}>
          Guardar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default EditUsersModal;
